import { document } from '@mgmresorts/wcl-utils';
import React, { ReactNode, useCallback, useMemo } from 'react';

import { EscKeyListenContext, EscKeyListenContextValue } from './EscKeyListenContext';

interface EscKeyListenContextProviderProps {
  children: ReactNode;
}

export const EscKeyListenContextProvider: React.FC<EscKeyListenContextProviderProps> = ({ children }) => {
  const [listeners, setListeners] = React.useState<Array<() => void>>([]);

  React.useEffect(() => {
    const handleDocumentKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && listeners.length > 0) {
        listeners[listeners.length - 1]();
      }
    };

    if (listeners.length > 0) {
      document?.addEventListener('keydown', handleDocumentKeydown);
    }

    return () => {
      if (listeners.length > 0) {
        document?.removeEventListener('keydown', handleDocumentKeydown);
      }
    };
  }, [listeners]);

  const subscribe = useCallback((listener: () => void) => {
    setListeners(st => [...st, listener]);

    return {
      unsubscribe: () => {
        setListeners(st => st.filter(fn => fn !== listener));
      },
    };
  }, []);

  const ctxValue: EscKeyListenContextValue = useMemo(
    () => ({
      subscribe,
    }),
    [subscribe],
  );

  return <EscKeyListenContext.Provider value={ctxValue}>{children}</EscKeyListenContext.Provider>;
};
